import { render, staticRenderFns } from "./modifyPasswd.vue?vue&type=template&id=9c967592&"
import script from "./modifyPasswd.vue?vue&type=script&lang=js&"
export * from "./modifyPasswd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports